import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Layout from "@/layouts/Layout";
import VueApexCharts from "vue-apexcharts";
import vClickOutside from "v-click-outside";
import VueEsc from "vue-esc";
import VModal from "vue-js-modal";
import VueCarousel from "vue-carousel";
import Toast from "vue-toastification";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/locale/tr";
import Vuelidate from "vuelidate";
import VueExcelXlsx from "vue-excel-xlsx";

Vue.config.devtools = false;
Vue.component("Layout", Layout);

Vue.config.productionTip = false;

Vue.use(require("vue-moment"));
Vue.use(Vuelidate);
Vue.use(VueCarousel);
Vue.use(DatePicker);
Vue.use(VueApexCharts);
Vue.use(VueEsc);
Vue.use(vClickOutside);
Vue.use(VModal, { dynamic: true, injectModalsContainer: true });
Vue.use(Toast, {
  transition: "Vue-Toastification__slideBlurred",
  maxToasts: 20,
  newestOnTop: true,
  position: "top-right",
  timeout: 7500,
  closeOnClick: true,
  pauseOnFocusLoss: false,
  pauseOnHover: false,
  draggable: false,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: "button",
  icon: true,
  rtl: false,
});
Vue.use(VueExcelXlsx);
Vue.component("apexchart", VueApexCharts);
store.dispatch("initAuth");
let userId = parseInt(localStorage.getItem("userId"));
const createVueInstance = () => {
  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount("#app");
};
store
  .dispatch("getMember", { id: userId })
  .then((response) => {
    if (response.data.id !== userId) {
      store.dispatch("logout");
    }
    createVueInstance();
  })
  .catch(() => {
    createVueInstance();
  });
